'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = require('react-utils/shallowEqual');

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Functions = require('../core/Functions');

var _BrowserTest = require('../utils/BrowserTest');

var _renderProp = require('../utils/propTypes/renderProp');

var RenderProp = _interopRequireWildcard(_renderProp);

var _Timers = require('../utils/Timers');

var _UIOverhang = require('./UIOverhang');

var _UIOverhang2 = _interopRequireDefault(_UIOverhang);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sides = ['top', 'bottom', 'left', 'right'];

var Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'UIScrollOverhang__Wrapper'
})(['position:relative;min-height:0;']);

var UIScrollOverhang = function (_PureComponent) {
  _inherits(UIScrollOverhang, _PureComponent);

  function UIScrollOverhang() {
    var _ref;

    _classCallCheck(this, UIScrollOverhang);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = UIScrollOverhang.__proto__ || Object.getPrototypeOf(UIScrollOverhang)).call.apply(_ref, [this].concat(args)));

    _this.delayedMeasureScrollableArea = function () {
      (0, _Timers.cancelSchedulerCallback)(_this._timeout); // Ensure only one callback is queued at a time
      _this._timeout = (0, _Timers.requestSchedulerCallback)(_this.measureScrollableArea);
    };

    _this.measureScrollableArea = function () {
      var thisEl = _reactDom2.default.findDOMNode(_this);

      // Bail out if our only children are the 4 scroll overhang elements
      if (thisEl == null || thisEl.children.length === 4) return;

      var childEl = thisEl.children[0];
      var computedStyles = getComputedStyle(childEl, null);

      // Patch for Firefox < 62: https://bugzilla.mozilla.org/show_bug.cgi?id=1467722
      if (computedStyles == null) return;

      var clientHeight = childEl.clientHeight,
          clientWidth = childEl.clientWidth,
          scrollHeight = childEl.scrollHeight,
          scrollLeft = childEl.scrollLeft,
          scrollTop = childEl.scrollTop,
          scrollWidth = childEl.scrollWidth;


      var isScrollable = function isScrollable(overflow) {
        return overflow === 'auto' || overflow === 'scroll';
      };
      var scrollsVertically = isScrollable(computedStyles.overflowY);
      var scrollsHorizontally = isScrollable(computedStyles.overflowX);

      var measuredScrollableArea = {
        top: scrollsVertically ? scrollTop : 0,
        bottom: scrollsVertically ? scrollHeight - clientHeight - scrollTop : 0,
        left: scrollsHorizontally ? scrollLeft : 0,
        right: scrollsHorizontally ? scrollWidth - clientWidth - scrollLeft : 0
      };

      if (!(0, _shallowEqual2.default)(measuredScrollableArea, _this.state.measuredScrollableArea)) {
        _this.setState({ measuredScrollableArea: measuredScrollableArea });
      }
    };

    _this.handleScroll = function (evt) {
      (0, _Functions.callIfPossible)(_this.props.onScroll, evt);
      _this.delayedMeasureScrollableArea();
    };

    _this.state = {
      measuredScrollableArea: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      }
    };
    return _this;
  }

  _createClass(UIScrollOverhang, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // IE needs a longer delay before measurement, or else it sometimes returns an absurdly large
      // scrollWidth.
      if ((0, _BrowserTest.isIE11)()) {
        this._frame = requestAnimationFrame(function () {
          _this2._frame = requestAnimationFrame(_this2.measureScrollableArea);
        });
      } else {
        this.delayedMeasureScrollableArea();
      }

      addEventListener('resize', this.delayedMeasureScrollableArea);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.measuredScrollableArea === this.state.measuredScrollableArea) {
        this.delayedMeasureScrollableArea();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      removeEventListener('resize', this.delayedMeasureScrollableArea);
      (0, _Timers.cancelSchedulerCallback)(this._timeout);
      cancelAnimationFrame(this._frame);
    }
  }, {
    key: 'getClonedChild',
    value: function getClonedChild(children, measuredScrollableArea) {
      var child = _react2.default.Children.only(children);
      var childTabIndex = child.props && child.props.tabIndex;
      var childIsScrollable = sides.some(function (side) {
        return measuredScrollableArea[side] > 0;
      });
      return _react2.default.cloneElement(child, {
        tabIndex: childIsScrollable ? childTabIndex || 0 : childTabIndex
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          forceOverhangs = _props.forceOverhangs,
          gradientColor = _props.gradientColor,
          Overhang = _props.Overhang,
          size = _props.size,
          rest = _objectWithoutProperties(_props, ['children', 'forceOverhangs', 'gradientColor', 'Overhang', 'size']);

      var measuredScrollableArea = this.state.measuredScrollableArea;


      var clonedChild = this.getClonedChild(children, measuredScrollableArea);

      var overhangProps = { gradientColor: gradientColor, size: size };

      // Fade smoothly from 1 (scrollable area exceeds overhang size) to 0 (no scrollable area)
      var getOpacity = function getOpacity(side) {
        return forceOverhangs[side] ? 1 : Math.min((measuredScrollableArea[side] || 0) / size, 1);
      };

      return _react2.default.createElement(
        Wrapper,
        _extends({}, rest, { onScroll: this.handleScroll }),
        clonedChild,
        _react2.default.createElement(Overhang, _extends({}, overhangProps, { opacity: getOpacity('top'), side: 'top' })),
        _react2.default.createElement(Overhang, _extends({}, overhangProps, {
          opacity: getOpacity('bottom'),
          side: 'bottom'
        })),
        _react2.default.createElement(Overhang, _extends({}, overhangProps, { opacity: getOpacity('left'), side: 'left' })),
        _react2.default.createElement(Overhang, _extends({}, overhangProps, {
          opacity: getOpacity('right'),
          side: 'right'
        }))
      );
    }
  }]);

  return UIScrollOverhang;
}(_react.PureComponent);

UIScrollOverhang.propTypes = {
  children: _propTypes2.default.element.isRequired,
  forceOverhangs: _propTypes2.default.shape({
    top: _propTypes2.default.bool,
    bottom: _propTypes2.default.bool,
    left: _propTypes2.default.bool,
    right: _propTypes2.default.bool
  }).isRequired,
  gradientColor: _UIOverhang2.default.propTypes.gradientColor,
  onScroll: _propTypes2.default.func,
  Overhang: RenderProp.getPropType(_UIOverhang2.default),
  size: _UIOverhang2.default.propTypes.size
};

UIScrollOverhang.defaultProps = {
  forceOverhangs: {
    top: false,
    bottom: false,
    left: false,
    right: false
  },
  gradientColor: _UIOverhang2.default.defaultProps.gradientColor,
  Overhang: _UIOverhang2.default,
  size: _UIOverhang2.default.defaultProps.size
};

UIScrollOverhang.displayName = 'UIScrollOverhang';

exports.default = UIScrollOverhang;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/scroll/UIScrollOverhang.js
// module id = 604
// module chunks = 177